import UUID from "./uuid";

export default class UUIDManager {
  uuid() {
    if (this._uuid == null) {
      this._uuid = UUID.v4();
    }

    return this._uuid;
  }

  clear() {
    delete this._uuid;
  }
}